export default __webpack_public_path__ + "icon_insurance.0a453fb67469be3ad01569e38ea909ce.svg";